import {
    usePaginatedResource,
    useResourceItem,
    useCreateResource,
    useEditResource,
    useDeleteResource,
} from "./useCrudResource"
import {
    getVehicleFuelUses,
    getVehicleFuelUse,
    createVehicleFuelUse,
    editVehicleFuelUse,
    deleteVehicleFuelUse,
    getAllVehicleFuelUses,
    getTrashedVehicleFuelUses,
    restoreVehicleFuelUse,
} from "api/vehicleFuelUses"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const VEHICLE_FUEL_USE_QUERY_KEY = "vehicle-fuel-uses"
export const VEHICLE_FUEL_USE_GROUP_QUERY_KEY = "vehicle-fuel-uses-group"

// -------------------- FETCH PAGINATED --------------------
export const useVehicleFuelUses = (params = {}, enabled = true) => {
  return usePaginatedResource(
    VEHICLE_FUEL_USE_QUERY_KEY,
    getVehicleFuelUses,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useVehicleFuelUse = (id, enabled = true) => {
  return useResourceItem(VEHICLE_FUEL_USE_QUERY_KEY, getVehicleFuelUse, id)
}

// -------------------- CREATE --------------------
export const useCreateVehicleFuelUse = () => {
  return useCreateResource(createVehicleFuelUse, VEHICLE_FUEL_USE_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditVehicleFuelUse = () => {
  return useEditResource(editVehicleFuelUse, VEHICLE_FUEL_USE_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteVehicleFuelUse = () => {
  return useDeleteResource(deleteVehicleFuelUse, VEHICLE_FUEL_USE_QUERY_KEY)
}

// -------------------- ADDITIONAL --------------------

// Get all vehicle fuel uses without pagination
export const useAllVehicleFuelUses = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_FUEL_USE_QUERY_KEY,
    getAllVehicleFuelUses,
    { ...params, all: true },
    true
  )
}

// Get trashed vehicle fuel uses
export const useTrashedVehicleFuelUses = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_FUEL_USE_QUERY_KEY,
    getTrashedVehicleFuelUses,
    params,
    true
  )
}

// Restore a trashed vehicle fuel use
export const useRestoreVehicleFuelUse = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreVehicleFuelUse,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([VEHICLE_FUEL_USE_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData([VEHICLE_FUEL_USE_QUERY_KEY, id], restoredItem)
    },
  })
}
